module.exports = __webpack_public_path__ + "p2_img2.jpg?36cbde024d6c09ab2b112c53ac0489c6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p2/p2_img2.jpg
// module id = 109
// module chunks = 0